import { render, staticRenderFns } from "./ManifestSearchPage.vue?vue&type=template&id=84ed7582&"
import script from "./ManifestSearchPage.vue?vue&type=script&lang=js&"
export * from "./ManifestSearchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports